// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1lN4B","fileBtn":"File_fileBtn__1reHf","closeBtn":"File_closeBtn__1uZs9","fileSelected":"File_fileSelected__2JZJu","disabled":"File_disabled__33GMp"};